import PropTypes from 'prop-types';
import React from 'react';

import '../ccm/Modal.css';
import { ButtonRed, ButtonWhite } from '../reusable';

const ConfirmSubmitModal = ({
  isOpen, fulfillmentType, changeSummary, storeCount, totalSelectedCount, onCancel, onConfirm,
}) => {
  if (!isOpen) return null;
  const typeLabel = fulfillmentType === 'BOPIS' ? 'BOPIS' : 'Ship From Store';
  return (
    <div className="modal-overlay">
      <div className="modal-content o2o-bulk-confirm-modal">
        <h2 className="headline-2">Confirm Bulk Update</h2>
        <div className="o2o-bulk-confirm-body">
          <p>
            {`This will update ${storeCount} of ${totalSelectedCount} selected store${totalSelectedCount === 1 ? '' : 's'} (${typeLabel}) with their edited values.`}
          </p>
          <details className="o2o-bulk-confirm-details">
            <summary>{`Show changes (${storeCount} store${storeCount === 1 ? '' : 's'})`}</summary>
            <div className="o2o-bulk-confirm-store-list">
              {changeSummary.map(({ storeId, storeAlias, changes }) => (
                <div key={storeId} className="o2o-bulk-confirm-store">
                  <strong>{storeAlias}</strong>
                  <ul className="o2o-bulk-confirm-list">
                    {changes.map((change) => (
                      <li key={change}>{change}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </details>
          <p className="text-color-accent">Please do not navigate away from this page while the update runs.</p>
        </div>
        <div className="o2o-bulk-confirm-actions">
          <ButtonWhite className="border" label="Cancel" onClick={onCancel} />
          <ButtonRed
            confirm={false}
            label={`Confirm: Update ${storeCount} store${storeCount === 1 ? '' : 's'}`}
            onClick={onConfirm}
          />
        </div>
      </div>
    </div>
  );
};

ConfirmSubmitModal.defaultProps = {
  changeSummary: [],
};

ConfirmSubmitModal.propTypes = {
  changeSummary: PropTypes.arrayOf(PropTypes.shape({
    changes: PropTypes.arrayOf(PropTypes.string).isRequired,
    storeAlias: PropTypes.string.isRequired,
    storeId: PropTypes.string.isRequired,
  })),
  fulfillmentType: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  storeCount: PropTypes.number.isRequired,
  totalSelectedCount: PropTypes.number.isRequired,
};

export default ConfirmSubmitModal;
